module.exports = __webpack_public_path__ + "static/media/photo292.0a6f6398.jpg";